export default __webpack_public_path__ + "static/media/matic-token-icon.da7b877d.svg";